
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sitemap-html",
      function () {
        return require("private-next-pages/sitemap-html.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sitemap-html"])
      });
    }
  